const tunaXML = (firstName, lastName, street, city, state, zip, dob) => {
    
    let payload =
        '<?xml version="1.0" encoding="utf-8"?>' +
        '<xmlrequest xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope" xmlns="http://www.netaccess.transunion.com/namespace">' +
        '<systemId>VELECTR1</systemId> ' +
        '<systemPassword>Jlw220jYtr4QKfJngaf2</systemPassword>' +
        '<productrequest>' +
        '<creditBureau xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://www.transunion.com/namespace" xsi:schemaLocation="http://www.transunion.com/namespace file:///H:/TUXML/tuxml_v2.18.xsd">' +
            '<document>request</document>'+
            '<version>2.36</version>'+
            '<transactionControl>'+
                '<userRefNumber>Credit Report</userRefNumber>'+
                '<subscriber>'+
                    '<industryCode>F</industryCode>'+
                    '<memberCode>2355720</memberCode>'+
                    '<inquirySubscriberPrefixCode>1231</inquirySubscriberPrefixCode>'+
                    '<password>Q2W4</password>'+
                '</subscriber>'+
                '<options>'+
                    '<processingEnvironment>production</processingEnvironment>'+
                    '<country>us</country>'+
                    '<language>en</language>'+
                    '<contractualRelationship>individual</contractualRelationship>'+
                    '<pointOfSaleIndicator>none</pointOfSaleIndicator>'+
                '</options>'+
            '</transactionControl>'+
            '<product>'+
                '<code>07000</code>'+
                '<subject>'+
                    '<number>1</number>'+
                    '<subjectRecord>'+
                        '<indicative>'+
                            '<name>'+
                                '<person>'+
                                    '<first>' + firstName + '</first>'+
                                    '<last>' + lastName + '</last>'+
                                '</person>'+
                            '</name>'+
                            '<address>'+
                                '<status>current</status>'+
                                '<street>'+
                                    '<unparsed>' + street + '</unparsed>'+
                                '</street>'+
                                '<location>'+
                                    '<city>' + city + '</city>'+
                                    '<state>' + state + '</state>'+
                                    '<zipCode>' + zip + '</zipCode>'+
                                '</location>'+
                            '</address>'+
                            '<socialSecurity>'+
                                '<number></number>'+
                            '</socialSecurity>'+
                            '<dateOfBirth>' + dob + '</dateOfBirth>' +
                        '</indicative>'+
                    '</subjectRecord>'+
                '</subject>'+
                '<responseInstructions>'+
                    '<returnErrorText>true</returnErrorText>'+
                    '<embeddedData>pdf</embeddedData>' +
                '</responseInstructions>'+
            '</product>'+
        '</creditBureau>' +
        '</productrequest>' +
        '</xmlrequest>'
    ;

    return payload;
};

export default tunaXML;
